import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage, injectIntl} from 'react-intl';

import {cancelBigStakeRequest as cancelBigStakeRequestAction} from 'actions/creators/BigStakeRequest';
import {
    setCashoutStatus as setCashoutStatusAction,
    createCashout as createCashoutAction
} from 'actions/creators/Cashout';

import * as CashoutStatuses from 'constants/CashoutStatus';
import * as BetStatuses from 'constants/BetStatus';
import * as StakeStatuses from 'constants/StakeStatus';
import * as BetCreateErrors from 'constants/BetCreateErrorStatus';
import * as BigStakeCancelError from 'constants/BigStakeCancelError';
import {resourceNames} from 'constants/accountResourceNames';
import {minAmount as MinAmountValues} from 'constants/StakeMinAmount';

const messages = defineMessages({
    betUnderConsideration: {
        id: 'bet_history.bet_under_consideration',
        defaultMessage: 'Ставка на подтверждении'
    },
    betUnderConsiderationToolTip: {
        id: 'bet_history.bet_under_consideration_tooltip',
        defaultMessage: 'Ставка на потверждении. Ещё-ещё-ещё. Ставка на потверждении. Ещё-ещё-ещё.'
    },
    accepted: {
        id: 'bet_status.accepted',
        defaultMessage: 'Принята'
    },
    canceled: {
        id: 'bet_status.canceled',
        defaultMessage: 'Отменена'
    },
    sold: {
        id: 'bet_status.sold',
        defaultMessage: 'Продана'
    },
    won: {
        id: 'bet_status.won',
        defaultMessage: 'Выиграла'
    },
    lost: {
        id: 'bet_status.lost',
        defaultMessage: 'Проиграла'
    },
    sell: {
        id: 'bet_history.sell',
        defaultMessage: 'Продать'
    },
    refund: {
        id: 'bet_history.refund',
        defaultMessage: 'Возврат'
    },
    sellCancel: {
        id: 'bet_history.sell_cancel',
        defaultMessage: 'Отмена'
    },
    cashoutAmountChanged: {
        id: 'bet_history.cashout_amount_changed',
        defaultMessage: 'Сумма продажи изменена'
    },
    cashoutConfirmation: {
        id: 'bet_history.cashout_confirmation',
        defaultMessage: 'Подтвердите продажу ставки,{br}cумма продажи'
    },
    eventStakeCashoutForbidden: {
        id: 'bet_history.event_stake_cashout_forbidden',
        defaultMessage: 'Продажа ставок на данное событие закрыта'
    },
    ratesChanged: {
        id: 'coupon.rate_changed',
        defaultMessage: 'Коэфф изменился'
    },
    bigStakeCancel: {
        id: 'bet_history.big_stake_cancel',
        defaultMessage: 'Отменить ставку'
    },
    insufficientFunds: {
        id: 'bet_history.errors.insufficient_funds',
        defaultMessage: 'Недостаточно средств на балансе'
    },
    accountLocked: {
        id: 'bet_history.errors.account_locked',
        defaultMessage: 'Ваш счет заблокирован'
    },
    systemNotAllowedForFreebet: {
        id: 'bet_history.errors.system_not_allowed_for_freebet',
        defaultMessage: 'Фрибет ставки типа "Система" запрещены'
    },
    incorrectStakeData: {
        id: 'bet_history.errors.incorrect_stake_data',
        defaultMessage: 'Некорректные данные по ставке'
    },
    minStakeAmount: {
        id: 'bet_history.errors.min_stake_amount',
        defaultMessage: 'Минимальная сумма ставки {minAmount} {currency}'
    },
    alternativeStake: {
        id: 'coupon.max_amount_hint',
        defaultMessage: 'Макс. {amount} {resource}'
    },
    not_possible_stake: {
        id: 'coupon.not_possible_stake',
        defaultMessage: 'Данная ставка невозможна'
    },
    incorrectVirtualStake: {
        id: 'bet_history.errors.incorrect_virtual_stake',
        defaultMessage: 'Некорректная ставка с виртуального счета'
    },
    incorrectFreebetStake: {
        id: 'bet_history.errors.incorrect_freebet_stake',
        defaultMessage: 'Некорректные данные по бесплатной ставке'
    },
    existingActiveStake: {
        id: 'bet_history.errors.existing_active_stake',
        defaultMessage: 'Ошибка системы'
    },
    noBigStakePermission: {
        id: 'bet_history.errors.no_big_stake_permission',
        defaultMessage: 'Крупные ставки запрещены'
    },
    freebetBigStake: {
        id: 'bet_history.errors.freebet_big_stake',
        defaultMessage: 'Фрибет ставка не может быть крупной'
    },
    bet_history_bet_not_accepted_by_terms:{
        id: 'bet_history.errors.bet_not_accepted_by_terms',
        defaultMessage: 'Ставка не принята, не соблюдены условия промокода'
    },
    coupon_bet_not_accepted: {
        id: "coupon.bet_not_accepted",
        defaultMessage: "Ставка не принята"
      },
      coupon_bet_not_accepted_by_terms: {
        id: "coupon.bet_not_accepted_by_terms",
        defaultMessage: "Ставка не принята, не соблюдены условия промокода"
      },
      "-1": {
        id: "coupon_bet_promocode_not_found1",
        defaultMessage: "Промокод не найден"
      },
      "-2": {
        id: "coupon_bet_coef_stakes_changed2",
        defaultMessage: "Коэффициент ставки был изменен"
      },
      "-21": {
        id: "coupon_bet_for_get_freebet_fill_balance21",
        defaultMessage:
          "Для получения фрибета необходимо пополнить счет на сумму {amount} {currency}"
      },
      "-23": {
        id: "coupon_bet_nessary_should_more23",
        defaultMessage: "Сумма ставок должна превышать {amount}"
      },
      "-22": {
        id: "coupon_bet_for_using_freebet_make_stake_more22",
        defaultMessage:
          "Для использования фрибета необходимо сделать ставку на сумму от {amount} {currency}"
      },
      "-24": {
        id: "coupon_bet_for_using_freebet_nessery_auth24",
        defaultMessage:
          "Для использования фрибета необходима идентификация учетной записи"
      },
      "-31": {
        id: "coupon_bet_validation_is_not_accept31",
        defaultMessage: "Промокод доступен только в {value}"
      },
      "-32": {
        id: "coupon_bet_for_stake_type32",
        defaultMessage: "Применимо к ставке типа: {amount}"
      },
      "-33": {
        id: "coupon_bet_min_coef_should33",
        defaultMessage: "Минимальный коэфицент должен быть {amount}"
      },
      "-34": {
        id: "coupon_bet_validation_is_not_accept_by_minCoef34",
        defaultMessage: "Коэффициент не должен превышать {amount}"
      },
      "-35": {
        id: "coupon_for_using_freebet_nesessarry_choose_more35",
        defaultMessage:
          "Для использования фрибета необходимо выбрать не менее {amount} событий."
      },
      "-36": {
        id: "coupon_bet_freebet_sum_not_equal_sum_stake36",
        defaultMessage: "Сумма фрибета меньше/больше суммы ставки"
      },
      "-37": {
        id: "coupon_bet_not_for_stake_type37",
        defaultMessage: "Не применимо к данному матчу"
      },
      "-38": {
        id: "coupon_bet_not_for_the_league38",
        defaultMessage: "Не применимо к данной лиге"
      },
      single: {
        id: 'bet_type.ordinar',
        defaultMessage: 'Ординар'
    },
    express: {
        id: 'bet_type.accumulator',
        defaultMessage: 'Экспресс'
    },
    system: {
        id: 'bet_type.system',
        defaultMessage: 'Система'
    }
});




class BetStatus extends React.Component {
    static propTypes = {
        id: React.PropTypes.string.isRequired,
        bet: React.PropTypes.object.isRequired,
        resourceId: React.PropTypes.number.isRequired,
        accountId: React.PropTypes.number.isRequired,
        cancelBigStakeRequestAction: React.PropTypes.func.isRequired,
        setCashoutStatusAction: React.PropTypes.func.isRequired,
        createCashoutAction: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.renderCashout = this.renderCashout.bind(this);

        this._onCancelBigStakeRequestClick = this._onCancelBigStakeRequestClick.bind(this);
        this._onSellClick = this._onSellClick.bind(this);
        this._onSellCancelClick = this._onSellCancelClick.bind(this);
        this._onSellAgreeClick = this._onSellAgreeClick.bind(this);
    }

    _onCancelBigStakeRequestClick(e) {
        e.preventDefault();

        const stakeId = this.props.bet.get('stakeId');

        this.props.cancelBigStakeRequestAction({
            betId: this.props.id,
            stakeId
        });
    }

    _onSellClick(e) {
        e.preventDefault();
        this.props.setCashoutStatusAction({
            betId: this.props.id,
            status: CashoutStatuses.MBOX_SHOWN
        });
    }

    _onSellCancelClick(e) {
        e.preventDefault();
        this.props.setCashoutStatusAction({
            betId: this.props.id,
            status: CashoutStatuses.AVAILABLE
        });
    }

    _onSellAgreeClick(e) {
        e.preventDefault();
        const bet = this.props.bet;
        const betId = this.props.id;

        const cashout = bet.get('cashout');
        const stakeId = bet.get('stakeId');
        const amount = cashout.get('amount');

        this.props.setCashoutStatusAction({
            betId,
            status: CashoutStatuses.SELL_REQUESTED
        });

        setTimeout(() => {
            this.props.createCashoutAction({
                betId,
                stakeId,
                amount
            });
        }, 10000);
    }

    renderCashout() {
        const cashout = this.props.bet.get('cashout');

        if (!cashout) {
            return (
                <div className="bet-controls-bottom cf">
                    <div className="bet-status cf">
                            <span className="bet-status__label bet-status__label__sold">
                                <FormattedMessage {...messages.sold} />
                            </span>
                    </div>
                </div>
            );
        }

        const cashoutAmount = cashout.get('amount');
        const cashoutState = cashout.get('state');

        switch (cashoutState) {
            case CashoutStatuses.AVAILABLE:
            {
                return (
                    <div className="bet-controls-bottom cf">
                        <div className="bet-status cf">
                            <span className="bet-status__label bet-status__label__accepted">
                                <FormattedMessage {...messages.accepted} />
                            </span>
                        </div>
                        <div className="bet-sell">
                            <a href="#" className="bet-sell__btn bet-sell__btn__js" onClick={this._onSellClick}>
                                <FormattedMessage {...messages.sell} />
                            </a>
                            <span className="bet-sell__amount">{cashoutAmount}</span>
                        </div>
                    </div>
                );
            }

            case CashoutStatuses.MBOX_SHOWN:
            {
                return (
                    <div className="bet-controls-bottom cf">
                        <div className="message-box message-box--sell-bet  message-box message-box--sell-bet--visible">
                            <div className="message-box--sell-bet__text">
                                <FormattedMessage {...messages.cashoutConfirmation} values={{br: (<br/>)}}/>
                            </div>
                            <div className="message-box--sell-bet__amount">
                                {cashoutAmount}
                            </div>
                            <div className="message-box--sell-bet__sell message-box--sell-bet__sell__js"
                                 onClick={this._onSellAgreeClick}>
                                <a href="#" className="message-box--sell-bet__btn--confirm">
                                    <FormattedMessage {...messages.sell} />
                                </a>
                            </div>
                            &nbsp;
                            <a href="#"
                               className="message-box--sell-bet__btn message-box--sell-bet__btn--cancel message-box--sell-bet__btn--cancel__js"
                               onClick={this._onSellCancelClick}>
                                <FormattedMessage {...messages.sellCancel} />
                            </a>
                        </div>
                    </div>
                );
            }

            case CashoutStatuses.SELL_REQUESTED:
            {
                return (
                    <div className="bet-controls-bottom cf">
                        <div className="message-box message-box--sell-bet  message-box message-box--sell-bet--visible">
                            <div className="message-box--sell-bet__text">
                                <FormattedMessage {...messages.cashoutConfirmation} values={{br: (<br/>)}}/>
                            </div>
                            <div className="message-box--sell-bet__amount">
                                {cashoutAmount}
                            </div>
                            <div className="message-box--sell-bet__sell message-box--sell-bet__sell__js  btn__disabled">
                                <div className="btn-preloader--visible">
                                    <div className="btn-preloader__bar btn-preloader__bar-first" />
                                    <div className="btn-preloader__bar btn-preloader__bar-second" />
                                    <div className="btn-preloader__bar btn-preloader__bar-third" />
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }

            case CashoutStatuses.SUCCESS:
            {
                return (
                    <div className="bet-controls-bottom cf">
                        <div className="bet-status cf">
                            <span className="bet-status__label bet-status__label__sold">
                                <FormattedMessage {...messages.sold} />
                            </span>
                        </div>
                    </div>
                );
            }

            case CashoutStatuses.REJECTED:
            {
                return (
                    <div className="bet-controls-bottom cf">
                        <div className="bet-status cf">
                            <span className="bet-status__label bet-status__label__accepted">
                                <FormattedMessage {...messages.accepted} />
                            </span>
                        </div>
                        <div className="bet-sell__status-message bet-sell__status-message__forbidden cf">
                            <FormattedMessage {...messages.eventStakeCashoutForbidden} />
                        </div>
                    </div>
                );
            }

            case CashoutStatuses.AMOUNT_CHANGED:
            {
                return (
                    <div className="bet-controls-bottom cf">
                        <div className="message-box message-box--sell-bet  message-box message-box--sell-bet--visible">
                            <div className="message-box--sell-bet__text">
                                <FormattedMessage {...messages.cashoutAmountChanged} />
                            </div>
                            <div className="message-box--sell-bet__amount">
                                {cashoutAmount}
                            </div>
                            <div className="message-box--sell-bet__sell message-box--sell-bet__sell__js"
                                 onClick={this._onSellAgreeClick}>
                                <a href="#" className="message-box--sell-bet__btn--confirm">
                                    <FormattedMessage {...messages.sell} />
                                </a>
                            </div>
                            &nbsp;
                            <a href="#"
                               className="message-box--sell-bet__btn message-box--sell-bet__btn--cancel message-box--sell-bet__btn--cancel__js"
                               onClick={this._onSellCancelClick}>
                                <FormattedMessage {...messages.sellCancel} />
                            </a>
                        </div>
                    </div>
                );
            }
        }
    }
    getStakeTypesInFormat = (arr) => {
        const stakeTypes = {
            1: this.props.intl.formatMessage(messages['single']),
            2: this.props.intl.formatMessage(messages['express']),
            3: this.props.intl.formatMessage(messages['system'])
        }
        return arr.map(item => {
            return stakeTypes[item]
        }).join('')
    }

    render() {
        if (!this.props.id) {
            return false;
        }
        const {bet, resourceId} = this.props;

        const betStatus = bet.get('betStatus');
        const stakeStatus = bet.get('stakeStatus');
        const betCreateError = bet.get('betCreateError');
        const resolution = bet.get('resolution');
        const rateChanged = bet.get('rateChanged');
        const bigStakeCancelError = bet.get('bigStakeCancelError');
        const alternativeStake = bet.get('alternativeStake');

        const currency = resourceNames[resourceId];
        const minAmount = MinAmountValues[currency];

        let cancellReasonMessage;

        if (rateChanged || betCreateError === 2) {
            cancellReasonMessage = (<span className="bet-status__text bet-status__text__cancelled">
                                            <FormattedMessage {...messages.ratesChanged}/>
                                        </span>);
        } else if (betCreateError === BetCreateErrors.INSUFFICIENT_FUNDS) { 
          cancellReasonMessage = (
            <span className="bet-status__text bet-status__text__cancelled">
              <FormattedMessage {...messages.insufficientFunds} />
            </span>
          )
        } else if (betCreateError && betCreateError.length) {
          cancellReasonMessage = betCreateError.map((err) => {
            return (
              <span key={err['ErrorCode']} className="bet-status__text bet-status__text__cancelled">
                {err['AdditionalValue'] ? (
                        <FormattedMessage {...messages[err['ErrorCode']]} values={{ amount: Array.isArray(err['AdditionalValue']) ? this.getStakeTypesInFormat(err['AdditionalValue']) : err['AdditionalValue'],currency }} />
                ) : (
                  <FormattedMessage {...messages[err['ErrorCode']]}/>
                )}
              </span>
            )
          })
        } else if (betCreateError === BetCreateErrors.ACCOUNT_LOCKED) {
          cancellReasonMessage = (
            <span className="bet-status__text bet-status__text__cancelled">
              <FormattedMessage {...messages.accountLocked} />
            </span>
          )
        } else if (betCreateError === BetCreateErrors.SYSTEM_NOT_ALLOWED_FOR_FREEBET) {
          cancellReasonMessage = (
            <span className="bet-status__text bet-status__text__cancelled">
              <FormattedMessage {...messages.systemNotAllowedForFreebet} />
            </span>
          )
        } else if (betCreateError === BetCreateErrors.INCORRECT_STAKE) {
          cancellReasonMessage = (
            <span className="bet-status__text bet-status__text__cancelled">
              <FormattedMessage {...messages.incorrectStakeData} />
            </span>
          )
        } else if (betCreateError === BetCreateErrors.MIN_STAKE_AMOUNT) {
          cancellReasonMessage = (
            <span className="bet-status__text bet-status__text__cancelled">
              <FormattedMessage {...messages.minStakeAmount} values={{ currency, minAmount }} />
            </span>
          )
        } else if (betCreateError === BetCreateErrors.INCORRECT_VIRTUAL_STAKE) {
          cancellReasonMessage = (
            <span className="bet-status__text bet-status__text__cancelled">
              <FormattedMessage {...messages.incorrectVirtualStake} />
            </span>
          )
        } else if (betCreateError === BetCreateErrors.INCORRECT_FREEBET_STAKE) {
          cancellReasonMessage = (
            <span className="bet-status__text bet-status__text__cancelled">
              <FormattedMessage {...messages.incorrectFreebetStake} />
            </span>
          )
        } else if (betCreateError === BetCreateErrors.EXISTING_ACTIVE_STAKE) {
          cancellReasonMessage = (
            <span className="bet-status__text bet-status__text__cancelled">
              <FormattedMessage {...messages.existingActiveStake} />
            </span>
          )
        } else if (betCreateError === BetCreateErrors.NO_BIG_STAKE_PERMISSION) {
          cancellReasonMessage = (
            <span className="bet-status__text bet-status__text__cancelled">
              <FormattedMessage {...messages.noBigStakePermission} />
            </span>
          )
        } else if (betCreateError === BetCreateErrors.FREEBET_BIG_STAKE) {
          cancellReasonMessage = (
            <span className="bet-status__text bet-status__text__cancelled">
              <FormattedMessage {...messages.freebetBigStake} />
            </span>
          )
        } else if (betCreateError === BetCreateErrors.INTERNAL_ERROR) {
          cancellReasonMessage = (
            <span className="bet-status__text bet-status__text__cancelled">
              <FormattedMessage {...messages.canceled} />
            </span>
          )
        } else if (betCreateError === BetCreateErrors.ALTERNATIVE_STAKE) {
          cancellReasonMessage = (
            <span className="bet-status__text bet-status__text__cancelled">
              <FormattedMessage
                {...messages.alternativeStake}
                values={{ resource: currency, amount: alternativeStake }}
              />
            </span>
          )
        } else if (betCreateError === BetCreateErrors.NOT_POSSIBLE_STAKE) {
          cancellReasonMessage = (
            <span className="bet-status__text bet-status__text__cancelled">
              <FormattedMessage {...messages.not_possible_stake} />
            </span>
          )
        } else if (resolution !== undefined) {
          cancellReasonMessage = <span className="bet-status__text bet-status__text__cancelled">{resolution}</span>
        }

        switch (betStatus) {
            case BetStatuses.INIT:
            case BetStatuses.IN_DELAY:
            case BetStatuses.CONFIRM_AWAIT:
                return (
                    <div className="bet-controls-bottom cf">
                        <div className="bet-status bet-status__preloader">
                            <div className="btn__disabled">
                                <div className="btn-preloader--visible">
                                    <div className="btn-preloader__bar btn-preloader__bar-first" />
                                    <div className="btn-preloader__bar btn-preloader__bar-second" />
                                    <div className="btn-preloader__bar btn-preloader__bar-third" />
                                </div>
                            </div>
                        </div>
                    </div>);

            case BetStatuses.STAKE_REQUEST:
                return (
                    <div className="bet-controls-bottom cf">
                        {(bigStakeCancelError === undefined ||
                        bigStakeCancelError !== BigStakeCancelError.CANCEL_NOT_POSSIBLE) &&
                        <div>
                            <div className="bet-status bet-status__preloader">
                                <div className="btn__disabled">
                                    <div className="btn-preloader--visible">
                                        <div className="btn-preloader__bar btn-preloader__bar-first" />
                                        <div className="btn-preloader__bar btn-preloader__bar-second" />
                                        <div className="btn-preloader__bar btn-preloader__bar-third" />
                                    </div>
                                </div>
                            </div>
                            <div className="bet-cancel">
                                <a href="#" onClick={this._onCancelBigStakeRequestClick}>
                                    <FormattedMessage {...messages.bigStakeCancel} />
                                </a>
                            </div>
                        </div>}
                    </div>);

            case BetStatuses.BET_PAY_REQUEST:
                return (<div className="bet-status cf">
                            <span className="bet-status__label bet-status__label__accepted">
                                <FormattedMessage {...messages.accepted} />
                            </span>
                </div>);

            case BetStatuses.CONFIRMED:
            {
                const cashout = bet.get('cashout');

                if (cashout) {
                    const cashoutState = cashout.get('state');
                    const cashoutAmount = cashout.get('amount');

                    if (cashoutState && cashoutAmount !== undefined) {
                        return this.renderCashout();
                    }
                }

                return (<div className="bet-status cf">
                            <span className="bet-status__label bet-status__label__accepted">
                                <FormattedMessage {...messages.accepted} />
                            </span>
                </div>);
            }

            case BetStatuses.REJECTED:
                return (
                    <div className="bet-controls-bottom cf">
                        <div className="bet-status cf">
                            <span className="bet-status__label bet-status__label__canceled">
                                <FormattedMessage {...messages.canceled} />
                            </span>
                            {cancellReasonMessage}
                        </div>
                    </div>);

            case BetStatuses.CALCULATED:
                switch (stakeStatus) {
                    case StakeStatuses.WON:
                        return (
                            <div className="bet-controls-bottom cf">
                                <div className="bet-status cf">
                                    <span className="bet-status__label bet-status__label__win">
                                        <FormattedMessage {...messages.won} />
                                    </span>
                                </div>
                            </div>);
                    case StakeStatuses.LOST:
                        return (
                            <div className="bet-controls-bottom cf">
                                <div className="bet-status cf">
                                    <span className="bet-status__label bet-status__label__loss">
                                        <FormattedMessage {...messages.lost} />
                                    </span>
                                </div>
                            </div>);
                    case StakeStatuses.REFUND:
                        return (
                            <div className="bet-controls-bottom cf">
                                <div className="bet-status cf">
                                    <span className="bet-status__label bet-status__label__win">
                                        <FormattedMessage {...messages.refund} />
                                    </span>
                                </div>
                            </div>);
                }
                break;

            case BetStatuses.CASHOUT:
                return this.renderCashout();

        }

        return false;
    }
}

function select(state, props) {
    const user = state.auth.get('user');
    if (!user) {
        return {};
    }
    const id = props.id;
    const bet = state.application.getIn(['betHistory', id]);
    const languageId = state.application.get('languageId');
    const resourceId = user.get('resourceId');
    const accountId = user.get('accountId');

    return {
        id,
        bet,
        languageId,
        resourceId,
        accountId
    };
}

export default connect(select, {
    cancelBigStakeRequestAction,
    setCashoutStatusAction,
    createCashoutAction
})(injectIntl(BetStatus));



// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/bet-history/BetStatus.jsx